module.exports = __webpack_public_path__ + "img/app-2.old.9e231a44.png";